<template>
  <div>
    <div id="main-content" class="relative flex justify-center w-full pt-12 pb-16 overflow-hidden md:pt-6 md:items-center hero header-height-top-space viewport-gutter">
      <div class="w-full md:my-auto">
        <div class="container w-full text-white">
          <div class="w-full max-w-68 md:max-w-xl xl:max-w-2xl">
            <h1 class="text-2.5xl leading-tight font-bold pb-4 md:text-4xl xl:pb-6 font-family-portado">
              {{ tr('pages.sales.landing.hero.title') }}
            </h1>
            <p class="text-lg font-normal md:max-w-2xl md:text-xl xl:text-2xl font-family-portado">
              {{ tr('pages.sales.landing.hero.subtitle') }}
            </p>
          </div>

          <div class="pt-6 xl:pt-12">
            <div class="max-w-75">
              <Button
                id="hero-action-button"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
                variant="primary"
                full-width
              >
                {{ tr('pages.sales.landing.hero.button') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative pb-16 -mt-10 viewport-gutter xl:pb-24">
      <div class="container">
        <div class="flex flex-col px-4 py-5 bg-white rounded shadow-10 md:flex-row md:py-6 xl:px-16 xl:py-10 text-au_gray-700 font-family-portado">
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-4 md:mr-6">
              <svg viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-7 md:w-8'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_21_1893)"><path d="M29 4.368h-2.332v-1.7a1.7 1.7 0 10-3.4 0v1.7H17.7V2.663c0-.936-.76-1.695-1.696-1.695h-.008c-.937 0-1.696.759-1.696 1.695v1.705H8.73V2.663c0-.936-.759-1.695-1.695-1.695h-.009c-.936 0-1.696.759-1.696 1.695v1.705h-2.33a3 3 0 00-3.001 3v20.665a3 3 0 003 3h26a3 3 0 003-3V7.368a3 3 0 00-3-3zm-4.832-1.7a.8.8 0 011.6 0v3.4a.8.8 0 01-1.6 0v-3.4zM15.2 2.662c0-.438.357-.795.796-.795h.008c.439 0 .796.357.796.795v3.41a.799.799 0 01-.804.796.797.797 0 01-.796-.796v-3.41zm-8.969 0c0-.438.358-.795.796-.795h.009c.438 0 .795.357.795.795v3.41a.799.799 0 01-.804.796.797.797 0 01-.796-.796v-3.41zM31.1 28.033c0 1.158-.942 2.1-2.1 2.1H3c-1.158 0-2.1-.942-2.1-2.1V7.368c0-1.158.942-2.1 2.1-2.1h2.331v.805c0 .937.76 1.696 1.696 1.696h.009c.936 0 1.695-.76 1.695-1.696v-.805H14.3v.805c0 .937.76 1.696 1.696 1.696h.008c.936 0 1.696-.76 1.696-1.696v-.805h5.568v.8a1.7 1.7 0 103.4 0v-.8H29c1.158 0 2.1.942 2.1 2.1v20.665zm-21.05-15.41h-4.1a.45.45 0 00-.45.45v4.1c0 .247.202.45.45.45h4.1c.248 0 .45-.203.45-.45v-4.1a.45.45 0 00-.45-.45zm-.45 4.1H6.4v-3.2h3.2v3.2zm8.45-4.1h-4.1a.45.45 0 00-.45.45v4.1c0 .247.202.45.45.45h4.1c.248 0 .45-.203.45-.45v-4.1a.45.45 0 00-.45-.45zm-.45 4.1h-3.2v-3.2h3.2v3.2zm8.45-4.1h-4.1a.45.45 0 00-.45.45v4.1c0 .247.202.45.45.45h4.1c.248 0 .45-.203.45-.45v-4.1a.45.45 0 00-.45-.45zm-.45 4.1h-3.2v-3.2h3.2v3.2zM10.05 20.7h-4.1a.451.451 0 00-.45.45v4.1c0 .248.202.45.45.45h4.1c.248 0 .45-.201.45-.45v-4.1a.451.451 0 00-.45-.45zm-.45 4.1H6.4v-3.2h3.2v3.2zm8.45-4.1h-4.1a.451.451 0 00-.45.45v4.1c0 .248.202.45.45.45h4.1c.248 0 .45-.201.45-.45v-4.1a.451.451 0 00-.45-.45zm-.45 4.1h-3.2v-3.2h3.2v3.2zm8.45-4.1h-4.1a.451.451 0 00-.45.45v4.1c0 .248.202.45.45.45h4.1c.248 0 .45-.201.45-.45v-4.1a.451.451 0 00-.45-.45zm-.45 4.1h-3.2v-3.2h3.2v3.2z"/></g><defs><clipPath id="clip0_21_1893"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>
            </div>
            <div class="leading-snug">
              <h3 class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.one.title') }}
              </h3>
              <p class="text-sm leading-normal xl:text-lg">
                {{ tr('pages.sales.landing.benefit.one.description') }}
              </p>
            </div>
          </div>
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-4 md:mr-6">
              <svg viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-7 md:w-8'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_21_1901)"><path d="M29.427 8.6C26.816 3.872 21.784.667 16 .667 7.532.667.667 7.53.667 16c0 8.468 6.865 15.333 15.333 15.333 5.784 0 10.816-3.205 13.427-7.933h3.24V8.6h-3.24zm-1.062 0h-6.499c-.737-3.052-1.913-5.472-3.339-6.799 4.177.743 7.731 3.288 9.838 6.8zM16 1.567c2.17 0 3.914 3.059 4.905 7.033h-9.81c.99-3.974 2.736-7.033 4.905-7.033zm-2.527.234c-1.426 1.327-2.602 3.747-3.34 6.8H6.56v4.732c1.295 0 2.363.96 2.574 2.217H1.59C1.804 8.658 6.865 2.976 13.473 1.8zM1.589 16.45h7.545c-.21 1.257-1.279 2.216-2.574 2.216V23.4h3.574c.737 3.052 1.913 5.473 3.339 6.8-6.608-1.175-11.67-6.857-11.884-13.749zM16 30.433c-2.168 0-3.913-3.06-4.905-7.034h9.812c-.992 3.975-2.737 7.034-4.906 7.034zm2.528-.234c1.426-1.328 2.602-3.748 3.34-6.8h6.498c-2.107 3.511-5.661 6.057-9.838 6.8zm13.24-7.7H7.46v-3.05a3.523 3.523 0 001.907-1.308 3.576 3.576 0 000-4.282 3.523 3.523 0 00-1.907-1.308v-3.05h24.307V22.5zm-17.291-9.166a.868.868 0 01-.868-.867.868.868 0 011.734 0c0 .478-.39.867-.866.867zm0 3.533a.868.868 0 01-.868-.866.868.868 0 011.734 0c0 .478-.39.866-.866.866zm0 3.534a.868.868 0 01-.868-.867.868.868 0 011.734 0c0 .478-.39.866-.866.866zM28.77 16a.6.6 0 01-.593.598h-2.516l-.077.096-2.662 3.322h-1.138l1.783-3.032.227-.386H21.232l-.075.075-.78.78h-1.13l.857-1.313.091-.14-.091-.14-.857-1.313h1.13l.78.78.075.075H23.795l-.227-.386-1.783-3.032h1.138l2.662 3.322.076.095h.123l2.393.001a.6.6 0 01.594.598z"/></g><defs><clipPath id="clip0_21_1901"><path fill="#fff" transform="translate(.667)" d="M0 0h32v32H0z"/></clipPath></defs></svg>
            </div>
            <div class="leading-snug">
              <h3 class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.two.title') }}
              </h3>
              <p class="text-sm leading-normal xl:text-lg">
                {{ tr('pages.sales.landing.benefit.two.description') }}
              </p>
            </div>
          </div>
          <div class="flex md:w-1/3">
            <div class="flex-shrink-0 mr-4 md:mr-6">
              <svg viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-7 md:w-8'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M27.766 6.324h-6.1v-1.79c0-.947-.767-1.715-1.713-1.715h-7.239c-.947 0-1.714.768-1.714 1.715v1.79H4.9a3.806 3.806 0 00-3.805 3.805v15.247a3.805 3.805 0 003.806 3.805h22.865a3.805 3.805 0 003.806-3.805V10.129a3.806 3.806 0 00-3.806-3.805zm-15.737-1.79c0-.379.307-.686.685-.686h7.239c.378 0 .685.307.685.686v1.79h-8.61v-1.79zm18.514 20.842a2.78 2.78 0 01-2.777 2.777H4.901a2.78 2.78 0 01-2.777-2.777V10.129A2.78 2.78 0 014.9 7.352h16.252l-2.694 3.773 2.863 13.3 6.704-1.443-2.864-13.3-4.009-2.33h6.613a2.78 2.78 0 012.777 2.777v15.247zM19.56 11.353l1.886-2.642 2.806 1.631 2.552 11.851-4.693 1.01-2.551-11.85zm-10.33.08v12.639a.515.515 0 01-1.029 0V11.433a.515.515 0 011.03 0z"/></svg>
            </div>
            <div class="leading-snug">
              <h3 class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.three.title') }}
              </h3>
              <p class="text-sm leading-normal xl:text-lg">
                {{ tr('pages.sales.landing.benefit.three.description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-12 md:px-6 lg:px-8 xl:px-20 xl:mb-24">
      <div class="container">
        <h2 id="get-voucher" class="px-4 pb-4 text-xl font-bold md:pb-6 md:text-2xl md:px-0 xl:text-2.5xl font-family-portado">
          {{ tr('pages.sales.landing.types.title') }}
        </h2>
        <div class="flex px-4 py-4 md:justify-center flex-col sm:flex-row md:py-0 md:px-0">
          <TypeCard
            :title="tr('pages.sales.landing.types.digital.title')"
            class="sm:mr-4 xl:mr-6 mb-4 sm:mb-0"
          >
            <template v-slot:image>
              <img
                srcset="~images/austrian/offers/digital-voucher2x.jpg 2x, ~images/austrian/offers/digital-voucher1x.jpg 1x "
                src="~images/austrian/offers/digital-voucher1x.jpg"
                class="rounded-t"
                alt=""
                role="presentation"
              >
            </template>

            <p class="text-sm xl:text-lg font-family-portado">
              {{ tr('pages.sales.landing.types.digital.benefit') }}

            </p>

            <template v-slot:buttons>
              <Button
                variant="primary"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
                full-width
              >
                {{ tr('pages.sales.landing.types.digital.button') }}
              </Button>
            </template>
          </TypeCard>

          <TypeCard
            v-if="false"
            :title="tr('pages.sales.landing.types.physical.title')"
            class="mr-4 xl:mr-6"
          >
            <template v-slot:image>
              <img
                srcset="~images/austrian/offers/digital-voucher2x.jpg 2x, ~images/austrian/offers/digital-voucher1x.jpg 1x "
                src="~images/austrian/offers/digital-voucher1x.jpg"
                class="rounded-t"
                alt=""
                role="presentation"
              >
            </template>

            <ul class="text-sm list-checkmark xl:text-lg">
              <li class="pb-2">
                {{ tr('pages.sales.landing.types.physical.benefit.one') }}
              </li>
              <li class="pb-2">
                {{ tr('pages.sales.landing.types.physical.benefit.two') }}
              </li>
              <li class="pb-2">
                {{ tr('pages.sales.landing.types.physical.benefit.three') }}
              </li>
            </ul>

            <template v-slot:buttons>
              <Button
                variant="primary-border"
                full-width
              >
                {{ tr('pages.sales.landing.types.physical.button') }}
              </Button>
            </template>
          </TypeCard>

          <TypeCard :title="tr('pages.sales.landing.types.existing.title')">
            <template v-slot:image>
              <img
                srcset="~images/austrian/offers/digital-voucher-app2x.jpg 2x, ~images/austrian/offers/digital-voucher-app1x.jpg 1x "
                src="~images/austrian/offers/digital-voucher-app1x.jpg"
                class="rounded-t"
                alt=""
                role="presentation"
              >
            </template>

            <p class="text-sm xl:text-lg font-family-portado">
              {{ tr('pages.sales.landing.types.existing.description') }}
            </p>

            <template v-slot:buttons>
              <Button
                v-if="false"
                variant="primary-border"
                class="mb-2"
                full-width
              >
                {{ tr('pages.sales.landing.types.existing.button.checkBalance') }}
              </Button>
              <Button
                variant="primary-border"
                href="https://austrian.com"
                full-width
              >
                {{ tr('pages.sales.landing.types.existing.button.redeem') }}
              </Button>
            </template>
          </TypeCard>
        </div>
      </div>
    </div>
    <div class="container mb-12 xl:mb-32">
      <HowItWorks />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/austrian/sale-landing-page/how-it-works.vue'
import Button from '~brand-components/austrian/button/button.vue'
import TypeCard from '~brand-components/austrian/type-card/type-card.vue'

export default Vue.extend({
  components: {
    Button,
    HowItWorks,
    TypeCard,
  },
})
</script>

<style lang="scss" scoped>
.hero {
  min-height: 440px;
  background: url("../../images/austrian/hero/mobile-3.jpg") left bottom / cover no-repeat;
}

@screen md {
  .hero {
    min-height: 635px;
    background: url("../../images/austrian/hero/tablet-3.jpg") left bottom / cover no-repeat;
  }
}

@screen xl {
  .hero {
    background: url("../../images/austrian/hero/desktop-3.jpg") right bottom / cover no-repeat;
  }
}
</style>
